import { SubjectRequest } from "@api/client";
import { subjectGetSubject } from "common/_redux/subject/actions";
import { subjectSelector } from "common/_redux/subject/selectors";
import BftAccordion from "common/components/accordion";
import BftButton from "common/components/button";
import { goToTop } from "common/helpers/common-utils";
import { AppRouterService } from "core/routes/app-router.service";
import { PathEnum } from "core/routes/path.enum";
import { useAppDispatch, useAppSelector } from "core/store/hooks";
import { layoutStepsSelector } from "layout/_redux/selectors";
import Anagrafica from "pages/onBoarding/step-3/_common-components/anagrafica";
import CarichePubbliche from "pages/onBoarding/step-3/_common-components/cariche-pubbliche";
import VerificaIdentita from "pages/onBoarding/step-3/_common-components/verifica-identita";
import { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { invitationSetShowHeader } from "../_redux/actions";
import { invitationInvitationSelector } from "../_redux/selectors";

const IdentificationPage: React.FC = () => {
	const dispatch = useAppDispatch();
	const navigate = useNavigate();

	const location = useLocation();

	const steps = useAppSelector(layoutStepsSelector);
	const invitation = useAppSelector(invitationInvitationSelector);
	const subject = useAppSelector(subjectSelector);

	const activeAccordionIndex =
		(steps
			?.find((s) => s.route == AppRouterService.get(PathEnum.identification))
			?.subSteps?.findIndex((ss) => ss.route == location.pathname) || 0) + 1;

	const goNext = (route: string) => {
		navigate(route);
	};

	const goBack = () => {
		navigate(-1);
	};

	useEffect(() => {
		if (location.pathname == AppRouterService.get(PathEnum.identification))
			navigate(AppRouterService.get(PathEnum.anagraficaInvitation), { replace: true });
	}, []);

	useEffect(() => {
		setTimeout(() => {
			const id = activeAccordionIndex > 1 ? `accordion-${activeAccordionIndex}` : null;
			goToTop(id);
		}, 300);
	}, [activeAccordionIndex]);

	useEffect(() => {
		dispatch(invitationSetShowHeader(true));

		if (invitation) {
			let request: SubjectRequest = {
				idPratica: invitation?.idPratica ?? "",
				idSoggetto: invitation?.idSubject ?? "",
			};

			dispatch(subjectGetSubject(request));
		}
	}, [invitation]);

	return (
		<section>
			<Row>
				<Col sm={12} lg={8}>
					<h2 className="mb-3 ms-3">Identificazione titolare effettivo</h2>
					<span className="gray">
						Completa le informazioni richieste e controlla che quelle già inserite siano corrette.
					</span>

					<BftAccordion
						title="Anagrafica"
						index={1}
						total={3}
						isActive={location.pathname == AppRouterService.get(PathEnum.anagraficaInvitation)}
						isCompleted={activeAccordionIndex > 1}
					>
						<Anagrafica
							subjectDetails={subject}
							idCliente={invitation?.idCliente}
							idPratica={invitation?.idPratica}
							onComplete={() =>
								goNext(AppRouterService.get(PathEnum.ulterioriInformazioniInvitation))
							}
							skipSaveStepStatus
						/>
					</BftAccordion>

					<BftAccordion
						title="Cariche pubbliche"
						index={2}
						total={3}
						isActive={
							location.pathname == AppRouterService.get(PathEnum.ulterioriInformazioniInvitation)
						}
						isCompleted={activeAccordionIndex > 2}
					>
						<CarichePubbliche
							subjectDetails={subject}
							idCliente={invitation?.idCliente}
							idPratica={invitation?.idPratica}
							onComplete={() => goNext(AppRouterService.get(PathEnum.verificaIdentitaInvitation))}
							skipSaveStepStatus
						/>
					</BftAccordion>

					<BftAccordion
						title="Verifica la tua identità"
						index={3}
						total={3}
						isActive={
							location.pathname == AppRouterService.get(PathEnum.verificaIdentitaInvitation)
						}
						isCompleted={activeAccordionIndex > 3}
					>
						<VerificaIdentita
							isInvitation
							subjectDetails={subject}
							idCliente={invitation?.idCliente}
							idPratica={invitation?.idPratica}
							onComplete={() => goNext(AppRouterService.get(PathEnum.invitationComplete))}
							skipSaveStepStatus
						/>
					</BftAccordion>

					<Row className="justify-content-between mx-1">
						<Col xs={1}>
							<BftButton className="btn-buffetti-secondary px-3" onClick={() => goBack()}>
								<i className="fas fa-arrow-left"></i>
							</BftButton>
						</Col>

						{/* <Col xs={10} md={11} className="">
							<BftButton
								className="btn-buffetti col-12"
								isDisabled={activeAccordionIndex <= 3}
								onClick={() => goNext()}
							>
								Vai allo step successivo
							</BftButton>
						</Col> */}
					</Row>
				</Col>
			</Row>
		</section>
	);
};
export default IdentificationPage;
